"use client"

import { useTheme } from "next-themes"
import { useEffect } from "react"

export function Favicon() {
  const { resolvedTheme } = useTheme()

  useEffect(() => {
    const updateFavicon = () => {
      const link = document.querySelector('link[rel="icon"]') as HTMLLinkElement
      if (!link) return

      if (resolvedTheme === 'dark') {
        link.href = '/favicon-dark.svg'
      } else {
        link.href = '/favicon-light.svg'
      }
    }

    updateFavicon()
  }, [resolvedTheme])

  return null
}
